<div class="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(14,165,233,0.15),_transparent_42%),linear-gradient(180deg,#0b1020_0%,#0f1117_40%,#090c14_100%)] text-slate-100 px-4 py-10">
  <div class="mx-auto w-full max-w-6xl">
    <div class="mb-5 flex justify-center">
      <img
        src="/assets/images/logo/fitmed-logo-coloured.svg"
        alt="FitMed"
        class="h-12 w-auto select-none drop-shadow-[0_8px_24px_rgba(0,0,0,0.35)]" />
    </div>

    <app-card class="block h-full min-h-0 w-full" [rounded]="true">
      <div header class="flex flex-col gap-4">
        <div>
          <h1 class="text-3xl font-semibold tracking-tight">Secure document upload</h1>
          <p class="mt-2 max-w-2xl text-sm leading-6 text-slate-300">
            Drop files into the panel below or use the upload action to add documents. You can preview, download, rename, and remove files before confirming the link.
          </p>
        </div>
      </div>

      <div body class="flex h-full min-h-0 flex-col gap-5 p-6 md:p-8">
        <div class="flex w-full">
          <app-button
            [btnTxt]="'Confirm Files'"
            buttonType="danger"
            [disabled]="!token || locked"
            (click)="openConfirmModal()">
          </app-button>
        </div>

        @if (error) {
          <div class="rounded-2xl border border-rose-500/30 bg-rose-500/10 px-4 py-3 text-sm text-rose-200">
            {{ error }}
          </div>
        }

        @if (success) {
          <div class="rounded-2xl border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-sm text-emerald-200">
            {{ success }}
          </div>
        }

        @if (locked) {
          <div class="rounded-2xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm text-amber-100">
            This secure link has been confirmed and is no longer accepting uploads.
          </div>
        } @else if (!token) {
          <div class="rounded-2xl border border-slate-700 bg-slate-900/70 px-4 py-3 text-sm text-slate-300">
            Missing or invalid secure upload token.
          </div>
        }

        <app-documents
          [currentPath]="''"
          [rootPath]="''"
          [subdirs]="subdirs"
          [docs]="docs"
          [loadingFiles]="loadingFiles"
          [loadingUpload]="loadingUpload"
          [uploadingFileCount]="uploadsInFlight"
          [fileOnly]="true"
          [allowDelete]="true"
          [uploadsDisabled]="uploadsDisabled"
          (downloadRequested)="onDownload($event)"
          (previewRequested)="onPreview($event)"
          (uploadRequested)="onUpload($event)"
          (renameRequested)="onRenameDocument($event)"
          (deleteRequested)="onDeleteDocument($event)">
        </app-documents>
      </div>
    </app-card>
  </div>
</div>

@if (confirmModalOpen) {
  <app-modal [maxWidth]="'620px'" [maxHeight]="'70vh'" [closeable]="!confirming">
    <div header>
      <div class="text-lg font-semibold text-slate-100">Confirm files</div>
    </div>

    <div body>
      <div class="space-y-4 p-5 text-sm leading-6 text-slate-200">
        <p>
          Once you confirm these files, this secure link will stop working for future uploads.
        </p>
        <p>
          If you need to upload more files later, you will need to create a new link from the iOS app just like before.
        </p>

        <div class="flex flex-wrap justify-end gap-3 pt-2">
          <app-button
            buttonType="warning"
            [disabled]="confirming"
            (click)="closeConfirmModal()">
            Cancel
          </app-button>
          <app-button
            buttonType="danger"
            [loading$]="confirming"
            [disabled]="confirming"
            (click)="confirmUploads()">
            Confirm Files
          </app-button>
        </div>
      </div>
    </div>
  </app-modal>
}
